import '../scss/styles.scss';

import $ from 'jquery';
window.$ = $;

import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swiper, { Navigation, EffectFade, Controller } from 'swiper';
import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from 'gsap';

import Movinwords from './movinwords';

import { preloader } from './projects/preloader';
import Menu from './projects/menu';

const imagesLoaded = require('imagesloaded');

let app = null;

export default class Main {
	constructor() {
		app = this;
		app.scroll = null;
		app.tl = null;
	}

	bindEvents() {
		$(document)
			.on('hasBgWhite', function (e, status, obj) {
				app.changeBg();
			})
			.on('hasBgWhiteFixed', function (e, status, obj) {
				app.changeText();
			});

		$('.js-scroll-to').bind('click', function (e) {
			e.preventDefault();
			let tg = $(this).attr('href') || $(this).attr('data-target');
			if (tg) {
				app.scroll.scrollTo(tg, {
					easing: [0.42, 0.0, 1.0, 1.0],
				});
			}
		});
	}

	setLocomotive() {
		app.scroll = new LocomotiveScroll({
			el: document.querySelector('[data-scroll-container]'),
			smooth: true,
			getDirection: true,
		});

		imagesLoaded($('img, video'), () => {
			$('body').removeClass('loading');
			app.scroll.update();
			this.setAnimatedText();
		});

		app.scroll.on('call', (func, status, obj) => {
			$(document).trigger(func, status, obj);
		});

		app.scroll.on('scroll', (args) => {
			if (args.scroll.y >= $('#firstSection').offset().top - 10) {
				$('.scroll-btn.bottom').addClass('off');
				$('.scroll-btn.top').removeClass('off');
			} else {
				$('.scroll-btn.top').addClass('off');
				$('.scroll-btn.bottom').removeClass('off');
			}
			if (
				(args.scroll.y > 70 && args.direction == 'up') ||
				args.scroll.y <= 70
			) {
				$('.main-nav').addClass('mobile--fixed');
			} else {
				$('.main-nav').removeClass('mobile--fixed');
			}
		});

		//Animazione img cover progetto
		if ($('#projectImg').length) {
			app.tl = gsap.timeline({ paused: true });
			app.tl.to(
				'#projectImgContainer',
				{ rotation: 10, scale: 0.8, ease: 'none' },
				0
			);
			app.tl.to('#projectImg', { scale: 1.2, ease: 'none' }, 0);

			app.scroll.on('scroll', (args) => {
				if (
					typeof args.currentElements['projectImageTarget'] ===
					'object'
				) {
					let progress =
						args.currentElements['projectImageTarget'].progress;
					app.tl.progress(progress);
				}
			});
		}
	}

	setSwiper() {
		const swiperGallery = new Swiper('.swiper-gallery', {
			modules: [Navigation],
			slidesPerView: 'auto',
			loop: true,
			loopedSlides: 5,
			spaceBetween: 20,
			navigation: {
				nextEl: '.next-gallery',
				prevEl: '.prev-gallery',
			},
		});

		$('.swiper-mobile').each(function (index) {
			var id = 'swiper' + index;
			$(this).attr('id', id);
			const swiperMobile = new Swiper('.swiper-mobile', {
				slidesPerView: 'auto',
				spaceBetween: 20,
			});
		});

		const reviewsBodySwiper = new Swiper('.reviews-body', {
			modules: [EffectFade],
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		});

		const reviewsSwiper = new Swiper('.swiper-thumbs', {
			modules: [Controller],
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 24,
			slideToClickedSlide: true,
			controller: {
				control: reviewsBodySwiper,
			},
		});
	}

	setProjectsMenu() {
		if ($('.menu').length) {
			const menuEl = document.querySelector('.menu');
			new Menu(menuEl);
		}
	}

	setScrollText() {
		const $textBgItems = $('.text-bg');
		for (var i = 0; i < $textBgItems.length; i++) {
			var $this = $($textBgItems[i]);
			var $width = Math.floor(
				$this.find('.text-bg-inner').outerWidth() + 50
			);
			var $speed = Math.floor(($width * 3) / 160);
			$this.css({
				'--tw': $width + 'px',
				'--ts': $speed + 's',
			});
		}
		/*
		$(window).resize(function () {
			for (var i = 0; i < $textBgItems.length; i++) {
				var $this = $($textBgItems[i]);
				$this.attr('style', '');
				var $width = Math.floor(
					$this.find('.text-bg-inner').outerWidth() + 50
				);
				var $speed = Math.floor(($width * 3) / 160);
				$this.css({
					'--tw': $width + 'px',
					'--ts': $speed + 's',
				});
			}
		});*/
	}

	setAnimatedText() {
		if ($('.animated-text').length) {
			const mw = new Movinwords({
				el: '.animated-text',
				autostart: false,
				duration: 400,
				offset: 40,
				delay: 150,
				transition: 'revealInBottom',
				highlight: {
					classname: 'hightlight',
					tag: 'b',
					words: ['remotely.'],
				},
				events: {
					end: (options) => {
						$('#btnAbout').addClass('is-inview');
					},
				},
			});

			setTimeout(() => {
				mw.start();
			}, 500);
		}
	}

	setMap() {
		if ($('#map').length) {
			var $markers = $('.map-marker');
			$('#worldAccordion .accordion-item').on('click', function () {
				var $item = $(this);
				var index = $item.index();
				var mapMarker = $markers[index];
				var position = $(mapMarker).position();
				$('#mapInner').css({
					'--pl': '-' + position.left + 'px',
					'--pt': '-' + position.top + 'px',
				});
				$markers.removeClass('active');
				$(mapMarker).addClass('active');
			});
		}
	}

	setButtons() {
		$('.btn-outline-dark, .btn-outline-light').each(function () {
			$(this).wrapInner('<span/>');
		});
	}

	changeBg() {
		$('.has-bg-dark').toggleClass('bg-light text-dark');
	}
	changeText() {
		$('.wrapper').toggleClass('text-dark');
	}

	render() {
		this.setSwiper();
		this.setLocomotive();
		this.setProjectsMenu();
		this.setScrollText(); //text bg
		this.setMap();
		this.setButtons();
		this.bindEvents();

		if (!('ontouchstart' in document.documentElement)) {
			document.documentElement.classList.add('no-touch');
		} else {
			document.documentElement.classList.add('touch');
		}
	}
}

$(document).ready(function () {
	let main = new Main();
	main.render();
});
